import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function ContactPortal() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    window.setTimeout(() => {
      setSubmitting(false);
      setName('');
      setEmail('');
      setSubject('');
      setMessage('');
      toast.success('Message received. Stephanie\u2019s office will respond shortly.');
    }, 700);
  };
  return <section id="contact" className="bg-slate-50 py-24 lg:py-32" data-id="element-61" data-mp="10fo27zt8c5nb">
      <div className="max-w-content mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16" data-id="element-62" data-mp="wec9vmiz16bf">
        <div data-id="element-63" data-mp="3mqkaqnlpk3au">
          <SectionHeading eyebrow="10. Contact" title="Direct Contact Portal" description="Please use the form to get in touch regarding executive opportunities, professional discussions, or potential areas of alignment. I welcome relevant enquiries and look forward to hearing from you." data-id="element-64" data-mp="3mr285nk3wnkc" />

          <div className="mt-10 space-y-5" data-id="element-65" data-mp="5b3vxvty224y">
            <div className="flex items-center gap-4" data-id="element-66" data-mp="a9f4824lc4l2">
              <MapPinIcon className="h-5 w-5 text-gold-dark shrink-0" strokeWidth={1.5} data-id="element-67" data-mp="a8m8dw766zhp" />
              <span className="text-sm text-slate-700" data-id="element-68" data-mp="e8wb8zzo19sc">Luxembourg / United States</span>
            </div>
            <div className="flex items-center gap-4" data-id="element-69" data-mp="jad9enqrmi58">
              <MailIcon className="h-5 w-5 text-gold-dark shrink-0" strokeWidth={1.5} data-id="element-70" data-mp="o96m4dy8a54c" />
              <a href="mailto:stephanie.meyer@totalmedia.lu" className="text-sm text-slate-700 hover:text-gold-dark transition-colors duration-200" data-id="element-71" data-mp="2l16xy0iqe9pd">
                stephanie.meyer@totalmedia.lu
              </a>
            </div>
            <div className="flex items-center gap-4" data-id="element-72" data-mp="2i15bevh5cwwo">
              <PhoneIcon className="h-5 w-5 text-gold-dark shrink-0" strokeWidth={1.5} data-id="element-73" data-mp="2dz1zk5qkfqav" />
              <a href="tel:+352621253609" className="text-sm text-slate-700 hover:text-gold-dark transition-colors duration-200" data-id="element-74" data-mp="2ryjgy01j81a7">
                +352 621 253 609
              </a>
            </div>
          </div>
        </div>

        <motion.form initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} onSubmit={handleSubmit} className="bg-white border border-slate-200 p-8 lg:p-10 space-y-5" data-id="element-75" data-mp="2wwuou589o1ps">
          <div className="grid sm:grid-cols-2 gap-5" data-id="element-76" data-mp="3kmp6d03j6egd">
            <div data-id="element-77" data-mp="3fnm7jxe594gu">
              <label htmlFor="contact-name" className="block text-xs font-semibold tracking-wide uppercase text-slate-500" data-id="element-78" data-mp="3fo5e6hycg6fk">
                Name
              </label>
              <input id="contact-name" type="text" required value={name} onChange={event => setName(event.target.value)} className="mt-2 w-full border border-slate-300 bg-white px-4 py-3 text-sm text-navy focus:outline-none focus:border-gold transition-colors duration-200" placeholder="Your full name" data-id="element-79" data-mp="74toggy273he" />
            </div>
            <div data-id="element-80" data-mp="3kd6i5rn6182q">
              <label htmlFor="contact-email" className="block text-xs font-semibold tracking-wide uppercase text-slate-500" data-id="element-81" data-mp="3kdpzp78wlug8">
                Email
              </label>
              <input id="contact-email" type="email" required value={email} onChange={event => setEmail(event.target.value)} className="mt-2 w-full border border-slate-300 bg-white px-4 py-3 text-sm text-navy focus:outline-none focus:border-gold transition-colors duration-200" placeholder="you@company.com" data-id="element-82" data-mp="3bk37ts7thbcb" />
            </div>
          </div>

          <div data-id="element-83" data-mp="3v5opifh51mee">
            <label htmlFor="contact-subject" className="block text-xs font-semibold tracking-wide uppercase text-slate-500" data-id="element-84" data-mp="3v56mmzzz09xi">
              Subject <span className="normal-case text-slate-400" data-id="element-85" data-mp="3q6vfix128diz">(optional)</span>
            </label>
            <input id="contact-subject" type="text" value={subject} onChange={event => setSubject(event.target.value)} className="mt-2 w-full border border-slate-300 bg-white px-4 py-3 text-sm text-navy focus:outline-none focus:border-gold transition-colors duration-200" placeholder="What is this regarding?" data-id="element-86" data-mp="3l9dertx754m2" />
          </div>

          <div data-id="element-87" data-mp="15gwk1n17bwx9">
            <label htmlFor="contact-message" className="block text-xs font-semibold tracking-wide uppercase text-slate-500" data-id="element-88" data-mp="15h61gm86kvrc">
              Message
            </label>
            <textarea id="contact-message" required rows={4} value={message} onChange={event => setMessage(event.target.value)} className="mt-2 w-full border border-slate-300 bg-white px-4 py-3 text-sm text-navy focus:outline-none focus:border-gold transition-colors duration-200 resize-none" placeholder="Share a few details. I look forward to hearing from you." data-id="element-89" data-mp="1cyckfubmgzb5" />
          </div>

          <button type="submit" disabled={submitting} className="inline-flex items-center justify-center bg-navy px-7 py-3.5 text-sm font-semibold tracking-wide text-white hover:bg-navy-light transition-colors duration-200 disabled:opacity-60" data-id="element-90" data-mp="z2qo12327d8p">
            {submitting ? 'Sending…' : 'Contact Me'}
          </button>
        </motion.form>
      </div>
    </section>;
}